import { useSelector } from 'react-redux';

import { Alert, Container } from '@mui/material';

import { useGetBillingStatusQuery } from 'api/billing-api';
import { userSelector } from 'store/slices/user-slice';

// App-wide dunning banner: shown on every page while the customer is in the grace period
// (service suspends soon) or suspended (top up to resume). Driven by users/billing-status;
// the daily billing pass maintains the underlying state.
const MS_PER_DAY = 86_400_000;

export const DunningBanner = () => {
  const idToken = useSelector(userSelector).user?.idToken;
  const isIdTokenReady = !!idToken?.__raw;
  const { data } = useGetBillingStatusQuery(undefined, { skip: !isIdTokenReady });

  const status = data?.status;
  if (!status?.dunningEnabled || !status.zeroBalanceSince) return null;

  if (status.suspendedAt) {
    return (
      <Container fixed maxWidth='xl' sx={{ mt: 2 }}>
        <Alert severity='error'>
          Your service is <strong>suspended</strong> — your balance has been depleted. Top up your balance to resume
          service immediately.
        </Alert>
      </Container>
    );
  }

  const daysLeft = status.graceEndsAt
    ? Math.max(0, Math.ceil((new Date(status.graceEndsAt).getTime() - Date.now()) / MS_PER_DAY))
    : null;

  return (
    <Container fixed maxWidth='xl' sx={{ mt: 2 }}>
      <Alert severity='warning'>
        Your balance is depleted.{' '}
        {daysLeft !== null ? (
          <>
            Service will be suspended in{' '}
            <strong>
              {daysLeft} day{daysLeft === 1 ? '' : 's'}
            </strong>{' '}
            unless you top up.
          </>
        ) : (
          'Top up to avoid service suspension.'
        )}
      </Alert>
    </Container>
  );
};
